import Create from './create/CreateContractTemplate';
import Edit from './edit/EditContractTemplate';
import Individual from './individual/ContractTemplate';

export default { Create, Edit, Individual };
